import React from "react";
import * as yup from "yup";
import Swal from "sweetalert2";
import AppForm from "../../../../../partials/content/Forms/AppForm";
import ConfirmUploadedStocks from "./confirmUploadedStocks";
import { DialogActions } from "@material-ui/core";
import { saveUploadedItemsStocks } from "../../../../../services/inventory/itemsMovement";
const itemsStocksSchema = () => {
  return yup.array().of(
    yup.object().shape({
      itemID: yup.number(),
    })
  );
};
function ConfirmUploadedStocksForm({
  uploadedItemsStocks = [],
  showUploadedStock = false,
  setOpenUploadFile,
  setShowUploadedStock,
  onConfirmSave,
}) {
  return (
    <AppForm
      headSubmitButton={true}
      initialValues={uploadedItemsStocks}
      validationSchema={itemsStocksSchema}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        /*Only process data with status Ready To Upload*/
        const readyToUpload = values.filter(function(row) {
          return row.statusID === 1;
        });
        if (readyToUpload.length > 0) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title: "Are you sure want to save this Items Stock mass upload ?",
              text:
                "Please note that you are responsible for this action. Only data with status Ready To Upload will be processed",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                for (const item of values) {
                  item.totalStock = parseFloat(item.totalStock);
                }
                saveUploadedItemsStocks(values).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Saved",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  onConfirmSave();
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        } else {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Failed",
            text: "You don't have data which has Ready To Upload status",
            icon: "error",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      }}
    >
      <ConfirmUploadedStocks />
      {showUploadedStock ? (
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenUploadFile(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
          <button
            type="button"
            className="btn btn-label-warning btn-md btn-pill btn-bold"
            onClick={() => {
              setShowUploadedStock(false);
            }}
          >
            <i className="fas fa-trash-alt"></i>
            Discard
          </button>
          <button
            type="submit"
            className="btn btn-success btn-md btn-pill btn-bold"
            onClick={() => {}}
          >
            <i className="fas fa-save"></i>
            Save
          </button>
        </DialogActions>
      ) : null}
    </AppForm>
  );
}

export default ConfirmUploadedStocksForm;
